export default {
    startLoading(state) {
        state.loading = true
    },
    stopLoading(state) {
        state.loading = false
    },
    updateSettings(state, settings) {
        state.settings = settings
    },
    setSessionToken(state, token) {
        state.session.token = token
    },
    setSessionRefreshToken(state, refreshToken) {
        state.session.refreshToken = refreshToken
    },
    setSessionMercureToken(state, mercureToken) {
        state.session.mercureToken = mercureToken
    },
    unsetTokens(state) {
        state.session = {
            token: null,
            refreshToken: null,
            mercureToken: null,
            user: {
                workProfiles: []
            },
            favoriteWorkProfiles: []
        }
    },
    setUserData(state, data) {
        state.session.user = data
    },
    setFavoriteWorkProfiles(state, data) {
        state.session.favoriteWorkProfiles = data
    },
    addWorkProfile(state, profile) {
        state.session.user.workProfiles['hydra:member'].push(profile)
    },
    saveProfileQuery(state, query) {
        state.profileFinder.query = query
    },
    setProfileSearchId(state, profileSearchId) {
        state.profileFinder.profileSearchId = profileSearchId
    },
    setProfileSearchProfile(state, data) {
        state.profileFinder.profiles[data.index] = data.profile
        if (data.profile.id && state.profileSearchSymplaEventsUsed) {
            state.profilesFoundBySymplaEvents[data.profile.id] = state.profileSearchSymplaEventsUsed
        }
    },
    unsetProfileSearchProfile(state, index) {
        state.profileFinder.profiles[index] = {}
    },
    resetProfileSearchProfiles(state) {
        state.profileFinder.profiles = []
        state.profileFinder.result = []
        state.profileFinder.currentIndex = 0
        state.profilesFoundBySimplaEvents = {}
    },
    restoreProfileBackup(state, profileId) {
        if (state.profileBackups[profileId]) {
            state.profileSearches[profileId].profiles = state.profileBackups[profileId].profiles
        }
    },
    setSearchProfileEvent(state, event) {
        state.profileFinder.event = event
    },
    updateProfileSearches(state, profileSearches) {
        state.profileSearches = profileSearches
    },
    resetProfileSearches(state) {
        state.profileSearches = []
    },
    setProfileSearchIndex(state, index) {
        state.profileFinder.currentIndex = index
    },
    increaseProfileSearchIndex(state) {
        state.profileFinder.currentIndex++
    },
    resetProfileFinderResult(state) {
        state.profileFinder.result = []
        state.profileFinder.page = 1
        state.profileFinder.reachedEnd = false
    },
    pushProfileFinderResult(state, data) {
        state.profileFinder.result.push(...data)
    },
    profileFinderReachedEnd(state, reachedEnd) {
        state.profileFinder.reachedEnd = reachedEnd
    },
    profileFinderNextPage(state) {
        state.profileFinder.page++
    },
    resetCastSearchResult(state) {
        state.castSearch.result = []
        state.castSearch.page = 1
        state.castSearch.reachedEnd = false
    },
    pushCastSearchResult(state, data) {
        state.castSearch.result.push(...data)
    },
    castSearchReachedEnd(state, reachedEnd) {
        state.castSearch.reachedEnd = reachedEnd
    },
    castSearchNextPage(state) {
        state.castSearch.page++
    },
    setProfiles(state, data) {
        state.profileSearches[data.id] = {
            id: data.id,
            profiles: data.profiles,
            type: data.type
        }
    },
    setProfileFinder(state, profileFinder) {
        state.profileFinder = profileFinder
    },
    resetProfileFinder(state) {
        state.profileFinder = {
            query: {},
            profiles: [],
            event: {},
            currentIndex: 0,
            page: 1,
            result: [],
            reachedEnd: false,
            profileSearchId: null
        }

        state.profileSearches = []
    },
    setJobDetails(state, jobDetails) {
        state.jobDetails = jobDetails
    },
    setUnreadMessages(state, messages) {
        state.unreadMessages = messages
    },
    setEventViewType(state, viewType) {
        state.defaultEventViewType = viewType
    },
    setSkipBlockingDateAlert(state, skip) {
        state.skipDateBlockingAlert = skip
    },
    updateUserProfilePicture(state, photoImages) {
        state.session.user.photo_images = photoImages
    },
    setUserLogin(state, login) {
        state.userLogin = login
    },
    acceptCookies(state) {
        state.acceptedCookies = true
    },
    updateProfileSearchesFees(state, profileSearches) {
        profileSearches.forEach(profileSearch => {
            state.profileSearches[profileSearch.id].fee = profileSearch.fee
        })
    },
    setImpersonationData(state, data) {
        state.impersonationData = data
    },
    resetImpersonationData(state) {
        state.impersonationData = {email: null, token: null}
    },
    setCreatingEvent(state, eventId) {
        state.creatingEvent = eventId
    },
    updateSymplaParticipations(state, symplaParticipations) {
        state.session.user.symplaParticipations = symplaParticipations
    },
    updateProfileSearchSymplaEventsUsed(state, profileSearchSymplaEventsUsed) {
        state.profileSearchSymplaEventsUsed = profileSearchSymplaEventsUsed
    },
    setSymplaEvents(state, symplaEvents) {
        state.symplaEvents = symplaEvents
    },
    setProfileSearchFilters(state, filters) {
        state.profileSearchFilters = filters
    },
    setCastSearchFilters(state, filters) {
        if (!filters.types) {
            filters.types = []
        }
        state.castSearchFilters = filters
    }
}
